import { render, staticRenderFns } from "./EstadoEgreso.vue?vue&type=template&id=6acaf2ea&scoped=true"
import script from "./EstadoEgreso.vue?vue&type=script&lang=js"
export * from "./EstadoEgreso.vue?vue&type=script&lang=js"
import style0 from "./EstadoEgreso.vue?vue&type=style&index=0&id=6acaf2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acaf2ea",
  null
  
)

export default component.exports